import React from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import AppIcon from "../assets/app-icon.svg";

import { useNavigate } from "react-router-dom";

export default function ArtistsGallery({ artists }) {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: 2,
          my: 4,
        }}
      >
        {artists?.map((artist, index) => (
          <ArtistCard key={index} artist={artist} />
        ))}
      </Box>
    </>
  );
}

export function ArtistCard({ artist, index }) {
  const navigate = useNavigate();
  return (
    <Card
      key={index}
      sx={{
        display: "flex",
        width: "100%",
        flexShrink: 0,
        height: 60,
      }}
      onClick={() => navigate(`/${artist.key}`)}
    >
      <CardMedia
        component="img"
        sx={{ width: 60, height: 60 }}
        image={artist.meta.profile || AppIcon}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minWidth: 100,
          px: 2,
        }}
      >
        <Typography variant="h7" sx={{ fontWeight: 600 }}>
          {artist.name || artist.key}
        </Typography>
      </Box>
    </Card>
  );
}
